import React from "react";
import * as S from "./TextArea.styled";

const TextArea = ({
  title,
  value,
  onChange,
  minLength,
  maxLength,
  hasError,
  errorMessage,
  tip,
  ...props
}) => {
  let typingTimer;
  const doneTypingInterval = 2000;
  return (
    <S.TextAreaContainer>
      {title && (
        <S.Title htmlFor={title} hasError={hasError}>
          {title}
        </S.Title>
      )}
      <S.StyledTextArea
        id={title}
        value={value}
        onChange={onChange}
        hasError={hasError}
        maxLength={maxLength}
        minLength={minLength}
        onKeyUp={() => {
          clearInterval(typingTimer);
          if (value) {
            typingTimer = setTimeout(props.onBlur, doneTypingInterval);
          }
        }}
        onPaste={props.onBlur}
        {...props}
      />
      {errorMessage && <S.ErrorText>{errorMessage}</S.ErrorText>}
      {tip && <S.TextTip>{tip}</S.TextTip>}
    </S.TextAreaContainer>
  );
};

export default TextArea;
